import logo from "../../static/images/dawid_logo.svg";
import items, {datasetTransferProcessing10} from "./gdpr_items.js";
import {
    getAllSharedTo,
    getNamesForTransfersLoop,
    getNumberOfDatasets,
    getNumberOfParties,
    getPartyName,
    listOfTransferNotProcessing10Parties,
    listOfTransferProcessing101112Parties
} from "./gdpr_flow_utils.js";

const version = "0.0.2";
const id = 1;
const name = "GDPR";
const disclaimerText = {
    title: 'Use conditions',
    body: [
        'The Data Agreement Wizard is a tool developed by ' +
        'ELIXIR-Luxembourg to facilitate data sharing agreements.',
        '**It does not constitute any legal advice.**',
        'Anyone using DAWID will do this under their own full responsibility and will need to adapt and verify the' +
        ' agreement draft generated by DAWID for their own situation with their legal services.',
        'ELIXIR-Luxembourg will not be liable for any errors in the agreement drafts or' +
        ' damages arising from the use of DAWID.',
        'More information can be found in the terms of services under which DAWID is operating.',
        '**** Please note: this tool is still in alpha version. Please be aware that bugs or even data loss' +
        ' are possible. ****',
        '_When working with DAWID, please be aware that the data is not persisted by default. You will have' +
        ' to create a session or export your data to be able to pause and resume your work._']
};
const loopsDefinitions = {
    dataset_info_loop: {
        name: "Cohorts",
        allowPreliminary: true,
        namePreliminarySection: 'Cohort\'s details',
        getIterationName: function (globals, loopState, loopIndex) {
            return loopState[loop_index - 1]["datasetDetails"]["values"][0]
        },
        loopType: 'cohorts',
        hasMoreIterations: function (states) {
            return getNumberOfDatasets(states) > 1;
        }
    },
    parties_info_loop: {
        name: "Parties",
        allowPreliminary: true,
        namePreliminarySection: 'Party\'s details',
        getIterationName: function (globals, loopState, loop_index) {
            return loopState[loop_index - 1]["partyDetails"]["values"][1]
        },
        loopType: 'parties'
    },
    dataset_samples_use: {
        name: "Samples receivers",
        allowPreliminary: false,
        getIterationName: function (globals, loopState, loop_index, loops, itemsStates) {
            const nbParties = getNumberOfParties(itemsStates);
            const datasetIndex = loops['dataset_info_loop'].index - 1;
            let samplesReceiversCount = 0;
            for (let i = 0; i < nbParties; i++) {
                const isSamplesReceivers = globals['SamplesReceivers'][datasetIndex][i];
                if (isSamplesReceivers === true) {
                    samplesReceiversCount++;
                    if (samplesReceiversCount === loop_index) {
                        return getPartyName(i, loops);
                    }
                }
            }
        },
        hasMoreIterations: function (states, globals, loops) {
            const nbParties = getNumberOfParties(states);
            const datasetIndex = loops['dataset_info_loop'].index - 1;
            let samplesReceiversCount = 0;
            for (let i = 0; i < nbParties; i++) {
                if (globals['SamplesReceivers'][datasetIndex][i] === true) {
                    samplesReceiversCount++;
                }
            }
            return samplesReceiversCount > 1;
        },
        loopType: 'parties'
    },
    dataset_transfer_processing101112: {
        name: "Parties with secondary, external or international transfers",
        allowPreliminary: false,
        restoreVariables: function (globals) {
            globals['WhereEarlyTermination'] = 'dataset_transfer_processing101112';
        },
        getIterationName: function (globals, loopState, loopIndex, loops, itemStates) {
            let parties;
            const datasetIndex = loops['dataset_info_loop'].index - 1;
            if (globals['WhereEarlyTermination'] === 'dataset_transfer_not_processing10') {
                parties = listOfTransferNotProcessing10Parties(globals, itemStates, datasetIndex);
            } else {
                parties = listOfTransferProcessing101112Parties(globals, itemStates)
            }
            const partyIndexI = parties[loopIndex - 1];
            return getPartyName(partyIndexI, loops);
        },
        hasMoreIterations: function (states, globals, loops) {
            return listOfTransferProcessing101112Parties(globals, states).length > 1;
        },
        loopType: 'parties'
    },
    dataset_transfer_not_processing10: {
        name: "Parties (primary sharing)",
        allowPreliminary: false,
        getIterationName: function (globals, loopState, loop_index, loops, itemStates) {
            const datasetIndex = loops['dataset_info_loop'].index - 1;
            const parties = listOfTransferNotProcessing10Parties(globals, itemStates, datasetIndex);
            const partyIndex = parties[loop_index - 1];
            return getPartyName(partyIndex, loops);
        },
        restoreVariables: function (globals) {
            globals['WhereEarlyTermination'] = 'dataset_transfer_not_processing10';
        },
        hasMoreIterations: function (states, globals, loops) {
            const datasetIndex = loops['dataset_info_loop'].index - 1;
            const nbDatasets = getNumberOfDatasets(states);
            const nbParties = getNumberOfParties(states);
            let simpleCase = false;
            if (nbDatasets === 1 && nbParties === 2) {
                if (globals['HasRole'][0]['P'] && globals['HasRole'][1]['R'] &&
                    !globals['HasRole'][0]['R'] && !globals['HasRole'][1]['P']) {
                    // data transfer from 0 to 1
                    simpleCase = true;
                }
                if (globals['HasRole'][1]['P'] && globals['HasRole'][1]['R'] &&
                    !globals['HasRole'][1]['R'] && !globals['HasRole'][0]['P']) {
                    // data transfer from 1 to 0
                    simpleCase = true;
                }
            }
            return !simpleCase && listOfTransferNotProcessing10Parties(globals, states, datasetIndex).length > 1;
        },
        loopType: 'parties'
    },
    transfer_not_processing10_to: {
        name: "Parties shared to",
        allowPreliminary: false,
        restoreVariables: function (globals) {
            globals['WhereEarlyTerminationInner'] = 'transfer_not_processing10_to';
        },
        getIterationName: function (globals, loopState, loop_index, loops, itemStates) {
            const {
                partyName,
            } = getNamesForTransfersLoop(loop_index, itemStates, globals, loops);
            return partyName;
        },
        hasMoreIterations: function (states, globals, loops) {
            const datasetIndex = loops['dataset_info_loop'].index - 1;
            const processingLoopName = "dataset_info_loop#" + globals['WhereEarlyTermination'] + '$' + loops['dataset_info_loop'].index;
            const parties = listOfTransferNotProcessing10Parties(globals, states, datasetIndex);
            let loop = loops[processingLoopName];
            const partiesIndex = loop !== undefined ? loop.index - 1 : 0;
            const partyIndexI = parties[partiesIndex];
            const selectedShareTo = getAllSharedTo(states, globals, partyIndexI, datasetIndex);
            return selectedShareTo.length > 1;
        },
        loopType: 'parties'
    },
    transfer_processing10_to: {
        name: "Parties shared to",
        allowPreliminary: false,
        restoreVariables: function (globals) {
            globals['WhereEarlyTerminationInner'] = 'transfer_processing10_to';
        },
        getIterationName: function (globals, loopState, loop_index, loops, itemStates) {
            const {
                partyName,
            } = getNamesForTransfersLoop(loop_index, itemStates, globals, loops);
            return partyName;
        },
        hasMoreIterations: function (states) {
            const selectedShareTo = states[datasetTransferProcessing10.id].values[0];
            return selectedShareTo.length > 1;
        },
        loopType: 'parties'
    }
};

const flow = {id, items, name, version, logo, disclaimerText, loopsDefinitions: loopsDefinitions};
export default flow;
